/**
 * @generated SignedSource<<a316b1698417e82dea5535ab76a81288>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ImportClientsBillFromsLoaderQuery$variables = {};
export type ImportClientsBillFromsLoaderQuery$data = {
  readonly viewer: {
    readonly actualPersonId: string | null;
    readonly component: string | null;
    readonly company: {
      readonly id: string;
      readonly billFroms: ReadonlyArray<{
        readonly id: string;
        readonly integration: string;
        readonly externalId: string;
      } | null> | null;
    } | null;
  } | null;
};
export type ImportClientsBillFromsLoaderQuery = {
  variables: ImportClientsBillFromsLoaderQuery$variables;
  response: ImportClientsBillFromsLoaderQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "import_clients_bill_froms"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"import_clients_bill_froms\")"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Company",
  "kind": "LinkedField",
  "name": "company",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "BillFrom",
      "kind": "LinkedField",
      "name": "billFroms",
      "plural": true,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "integration",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "externalId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ImportClientsBillFromsLoaderQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ImportClientsBillFromsLoaderQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v3/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7ae828bc8a2017220c120fd70dcd4078",
    "id": null,
    "metadata": {},
    "name": "ImportClientsBillFromsLoaderQuery",
    "operationKind": "query",
    "text": "query ImportClientsBillFromsLoaderQuery {\n  viewer {\n    actualPersonId\n    component(name: \"import_clients_bill_froms\")\n    company {\n      id\n      billFroms {\n        id\n        integration\n        externalId\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "4da0a3cd442b899789b688e776a22b88";

export default node;
